import React, { Component } from 'react';
import _ from 'lodash';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { MyPATDialog, MyPATSelect, MyPATTextField, MyPATTextArea } from '../../common';
import CloseRounded from '@material-ui/icons/Cancel';
import Button from '@material-ui/core/Button';
import courseService from "../services/courseService";
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { showMsg } from '../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { styles } from '../styling/component/RevisionMilestone'


interface ReviewMilestoneProps extends WithStyles<typeof styles> {
	revisionMilestoneOpen: Boolean,
	revisionMilestoneCloseHandler: Function,
	milestoneData: any,
	showMsg: (msg: string, vari: string) => void,
	courseID: string
	startDate: any,
}

interface ReviewMilestoneStates {
	chaptersData: any,
	addedChapters: any,
	milestoneName: String,
	milestoneDuration: Number,
	milestoneDurationType: Number,
	milestoneObjective: String,
	milestoneSelected: any
}

class ReviewMilestone extends Component<ReviewMilestoneProps, ReviewMilestoneStates> {
	constructor(props: ReviewMilestoneProps) {
		super(props);
		this.state = {
			chaptersData: [],
			addedChapters: [],
			milestoneName: "",
			milestoneDuration: 0,
			milestoneDurationType: 0,
			milestoneObjective: "",
			milestoneSelected: ""
		};

		this.addChapters = this.addChapters.bind(this)
		this.removeChapters = this.removeChapters.bind(this)
	};

	addChapters(event: any) {
		var name = event.currentTarget.getAttribute("data-name")
		var key = event.currentTarget.getAttribute("data-id")
		var index = event.currentTarget.getAttribute("data-index")

		var { addedChapters } = this.state

		var dataArr = addedChapters.filter(function (value: any) {
			return value.id == key
		})
		if (dataArr.length == 0) {
			addedChapters.push({
				"id": key,
				"name": name
			})
			this.setState({
				addedChapters: addedChapters
			})

		} else {
			this.props.showMsg("Chapter already present", "error")
		}
	}


	removeChapters(id: any) {
		var { addedChapters } = this.state
		var dataArr = addedChapters.filter(function (value: any) {
			return value.id !== id
		})
		this.setState({
			addedChapters: dataArr
		})
	}

	handleNameChange = async (event: any) => {
		this.setState({ milestoneName: event.target.value });
	}

	handleDurationChange = async (event: any) => {
		this.setState({ milestoneDuration: event.target.value });
	}

	handleDurationType = async (event: any) => {
		this.setState({ milestoneDurationType: event.target.value });
	}

	handleObjective = async (event: any) => {
		this.setState({ milestoneObjective: event.target.value });
	}



	handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		var self = this;
		const { courseID } = this.props

		var { milestoneName, milestoneDuration, milestoneDurationType, milestoneObjective, addedChapters, milestoneSelected } = this.state
		if (addedChapters.length == 0) {
			self.props.showMsg('Please select milestone', 'error');
			return
		}

		let chapterArr : any = [];
		for (let i = 0; i < addedChapters.length; i++) {
			chapterArr.push(addedChapters[i].id)
		}

		if (chapterArr.length == 0) {
			self.props.showMsg('No milestone selected', 'error');
			return
		}
		var parameter = {
			"name": milestoneName,
			"tentativeDuration": milestoneDurationType,
			"number": milestoneDuration,
			"objective": milestoneObjective,
			"milestoneIds": chapterArr
		}

		courseService.addReviewMilestone(courseID, parameter).then((responseData: any) => {

			if (responseData.statusCode === 200) {
				let responseObj = responseData.responseObject
				if (!_.isEmpty(responseObj) && responseData.statusCode === 200) {
					self.props.showMsg(responseData.responseMessage, 'success');
					self.props.revisionMilestoneCloseHandler()
				} else {
					self.props.showMsg(responseData.message, 'error');
				}
			} else {
				self.props.showMsg(responseData.responseMessage, 'error');
			}
		});
	}

	displayDuration = () => {
		let durationMessage: string = '';
		const formatDate = (date: any) => {
			const months = [
				'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
			];

			return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
		}

		const { milestoneDuration, milestoneDurationType }: any = this.state;
		const startDate = _.get(this.props, 'startDate', '');

		let endDate = '(Select duration from above)';

		if (!_.isEmpty(milestoneDuration) && !_.isEmpty(milestoneDurationType)) {
			let date = new Date(startDate);
			switch (milestoneDurationType) {
				case 'Days': {
					date.setDate(date.getDate() + _.toNumber(milestoneDuration)  - 1)
				}
					break;

				case 'Weekly': {
					date.setDate(date.getDate() + (_.toNumber(milestoneDuration) * 7) - 1)
				}
					break;

				case 'Monthly': {
					date.setDate(date.getDate() + (_.toNumber(milestoneDuration) * 30) - 1)
				}
					break;

				case 'Yearly': {
					date.setDate(date.getDate() + (_.toNumber(milestoneDuration) * 365) - 1)
				}
					break;
			}

			endDate = formatDate(date);
		}


		if (!_.isEmpty(startDate)) {
			const date: any = formatDate(new Date(startDate));
			durationMessage = `${date} - ${endDate}`;
		}

		return durationMessage;
	}

	render() {
		const { classes, revisionMilestoneOpen, revisionMilestoneCloseHandler, milestoneData } = this.props;
		const { chaptersData, addedChapters, milestoneSelected } = this.state;
		const _self = this;
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		return (
			<>
				<MyPATDialog
					dialogHeading={<Typography className={classes.headerLeft}>Create Revision Milestone</Typography>}
					dialogOpen={revisionMilestoneOpen}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					onDialogClose={revisionMilestoneCloseHandler}
				>
					<form onSubmit={this.handleSubmit.bind(this)} >
						<Grid container>
							<Grid container>
								<Grid item xs={2}>
									<img style={{ width: "120px", height: "108px" }} src="/assets/img/course/revisionmilestone.png" alt="Milestone" />
								</Grid>
								<Grid item xs={4}>
									<Grid container alignItems="center" spacing={8}>
										<Grid item xs={12}>
											<Typography variant="h6">Name</Typography>
										</Grid>
										<Grid item xs={12}>
											<MyPATTextField
												inputId="milestoneName"
												name="milestoneName"
												onChange={this.handleNameChange}
												fullWidthControl
												placeholder="Name"
												inputProps={{
													required: true,
													minLength: 3
												}}
											/>
										</Grid>
									</Grid>
								</Grid>

								<Grid item xs={6} className={classes.tentativeDuration}>
									<Grid container alignItems="center" spacing={8}>
										<Grid item xs={12}>
											<Typography variant="h6">Tentative Duration</Typography>
										</Grid>

										<Grid item xs={8}>
											<MyPATSelect
												multiple
												fullWidthControl
												required
												onChange={this.handleDurationChange}
												label=""
												inputId="milestoneDurationNo"
												name="milestoneDurationNo"
											>
												<option value="">Select No</option>
												{
													[...Array(10)].map(function (v, i) {
														return <option value={i + 1}>{i + 1}</option>
													})
												}
											</MyPATSelect>
										</Grid>

										<Grid item xs={4}>
											<MyPATSelect
												multiple
												fullWidthControl
												onChange={this.handleDurationType}
												label=""
												inputId="milestoneDays"
												name="milestoneDays"
												inputProps={{
													required: true
												}}
											>
												<option value="">Select</option>
												<option value="Days">Days</option>
												<option value="Weekly">Weeks</option>
												<option value="Monthly">Months</option>
												<option value="Yearly">Years</option>
											</MyPATSelect>
										</Grid>

										<Grid item xs={12}>
											<Typography>
												{this.displayDuration()}
											</Typography>
										</Grid>
									</Grid>
								</Grid>
							</Grid>

							<Typography variant="h6" style={{ marginTop: "45px" }}>

								Select Milestones to Revise

							</Typography>

							<Grid container className={classes.cardContainer}>
								{
									addedChapters.map((value: any, index: any) => {
										return <div key={`${value._id}  ${index}`} className={classes.breadCrumbs}>
											{value.name} <CloseRounded onClick={() => { _self.removeChapters(value.id) }} />
										</div>
									})
								}
								<Grid item xs={12} style={{ margin: "10px" }}>
									{
										milestoneData.map((value: any, index: any) => (
											<div key={`${value._id}  ${index}`} data-index={index} data-name={value.name} data-id={value._id} onClick={_self.addChapters} className={classes.chaptersDiv}>
												{value.name}
											</div>
										))
									}
								</Grid>
							</Grid>

							<Grid item xs={12} className={classes.marginTop20} >
								<Typography variant="h6">Objective</Typography>
								<MyPATTextArea
									inputId="milestoneObjective"
									name="milestoneObjective"
									placeholder="Describe the goal you want to achieve by the end of this milestone."
									onChange={this.handleObjective.bind(this)}
									rows="5"
									multiline
									fullWidthControl
								/>
							</Grid>

						</Grid>

						<Grid item xs={12}>
							<Button
								variant="contained"
								type="submit"
								color="primary"
								className={classes.btnAlign}
							>
								Create Milestone
						</Button>
						</Grid>
						<br />
						<br />
					</form>
				</MyPATDialog>
			</>
		)
	}
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg
		// ServerAlertAction
	},
	dispatch
);


// @ts-ignore
export default connect(null, mapDispatchToProps)(withStyles(styles)(ReviewMilestone));